import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import styles from "./SelectedMapObject.module.scss";
import goIcon from "./go.svg";
import pinsData from "../../pins";
import achievements from "../../achievements";
import localforage from "localforage";
import { STORAGE_KEYS } from "../../constants/storage";

import { saveVisitedPin } from "../../visitedPinsStorage";

const SelectedMapObject = ({ id, name, title, title2 = null }) => {
  const navigate = useNavigate();
  const [cachedImage, setCachedImage] = useState(null);

  useEffect(() => {
    const loadCachedImage = async () => {
      const imagePath = `/data/pin-images/${name}.png`;
      const cachedImageBlob = await localforage.getItem(
        `${STORAGE_KEYS.IMAGES}_${imagePath}`
      );
      if (cachedImageBlob) {
        setCachedImage(URL.createObjectURL(cachedImageBlob));
      }
    };

    loadCachedImage();

    return () => {
      if (cachedImage) {
        URL.revokeObjectURL(cachedImage);
      }
    };
  }, [name]);

  const handleClick = async () => {
    const pin = pinsData.find((pin) => pin.id === id);
    if (pin) {
      pin.visited = true;
      try {
        await saveVisitedPin(pin.name);
      } catch (error) {
        console.error("Error saving visited pin:", error);
      }
    }

    const achievement = achievements.find((ach) => ach.id === id);
    if (achievement) {
      achievement.viewed = true;
    }

    navigate(`/places/${name}`);
  };

  const imagePath = `/data/pin-images/${name}.png`;

  return (
    <div className={styles.selectedMapObject} onClick={handleClick}>
      <img
        src={cachedImage || imagePath}
        alt={title}
        className={styles.image}
      />
      <div className={styles.textContainer}>
        <span className={styles.text}>{title}</span>
        {title2 && <span className={styles.text}>{title2}</span>}
      </div>
      <img src={goIcon} alt="Go" className={styles.goIcon} />
    </div>
  );
};

SelectedMapObject.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  title2: PropTypes.string,
};

export default SelectedMapObject;
